import { render } from "./Sculptures.vue?vue&type=template&id=033cf009"
import script from "./Sculptures.vue?vue&type=script&lang=js"
export * from "./Sculptures.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__